// extracted by mini-css-extract-plugin
export default {"bars":"SmallSizeLinks_bars__OCX8e","wrapper":"SmallSizeLinks_wrapper__dmc3y"};